import React, { useEffect } from 'react'
import { useConfiguratorContext } from '@augmatica/iframe-interface-react'

import { setViewInside } from '../../store/ui/uiSlice'

import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { useAppSelector, useAppDispatch } from '../../hooks'

const InsideOutsideToggle: React.FC = () => {
  const configurator = useConfiguratorContext()
  const { content } = useAppSelector((state) => state.init)
  const { viewInside } = useAppSelector((state) => state.ui)

  const dispatch = useAppDispatch()

  const handleChange = (): void => {
    dispatch(setViewInside(!viewInside))
  }

  useEffect(() => {
    if (viewInside) {
      configurator.setCameraView('loft' as any)
      configurator.setVisibility({ roof: false })
    } else {
      configurator.setCameraView('front')
      configurator.setVisibility({ roof: true })
    }
  }, [viewInside])

  const ButtonStyle = {
    '@media (min-width: 1024px)': {
      width: '90px',
      fontSize: '16px',
    },
    '&.Mui-selected': {
      borderRadius: '100px',
      backgroundColor: '#ffffff',
      '@media (min-width: 1024px)': {
        borderRadius: '3px',
        margin: '1px',
      },

      '&:hover': {
        backgroundColor: '#ffffff',
      },
    },
    '&:not(.Mui-selected)': {
      border: 'none',
    },
  }

  return (
    <ToggleButtonGroup
      color="primary"
      value={viewInside}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
      // For refrence see this link https://mui.com/system/getting-started/the-sx-prop/
      sx={{
        backgroundColor: '#d5dbd7',
        borderRadius: '100px',
        '@media (min-width: 1024px)': {
          borderRadius: '3px',
        },
      }}
    >
      <ToggleButton value={false} sx={ButtonStyle}>
        {content?.props?.loft?.outside}
      </ToggleButton>
      <ToggleButton value={true} sx={ButtonStyle}>
        {content?.props?.loft?.inside}
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default InsideOutsideToggle
